import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Footer.css';

const Footer: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['footer'];

  return (
    <footer className="bg-red text-white py-4">
      <Container>
        <Row className="mb-4">
          <Col md={6} className="pr-5">
            <h3>{t.company}</h3>
            <p>{t.description}</p>
          </Col>
          <Col md={3}>
            <h4>{t.navigation}</h4>
            <ul className="list-unstyled">
              <li>{t.home}</li>
              <li>{t.about}</li>
              <li>{t.reviews}</li>
              <li>{t.contact}</li>
            </ul>
          </Col>
          <Col md={3}>
            <h4>Kontakt</h4>
            <p>{t['contact-info'].phone}</p>
            <p>{t['contact-info'].email}</p>
          </Col>
        </Row>
      </Container>
      <div className="white-bar"></div>
      <Container>
        <Row>
          <Col className="text-center pt-4">
            <p>{t.copyright}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
